/**
 * UUID v4 generator, the one home for random ids in app code
 * (`scripts/check-canonical-homes.mjs` rule `random-uuid`). Falls back when
 * `crypto.randomUUID` is missing: Android WebViews older than Chrome 92, old
 * Safari, plain-HTTP contexts, Node < 19 (#2425).
 */
export function genUuid() {
  const c = typeof crypto !== 'undefined' ? crypto : undefined;
  if (typeof c?.randomUUID === 'function') return c.randomUUID();
  // RFC 4122 §4.4 v4 layout: version nibble 4, variant bits 10xx.
  const bytes = new Uint8Array(16);
  if (typeof c?.getRandomValues === 'function') c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i++) bytes[i] = Math.random() * 256 | 0;
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
